<template>
  <div class="product-content">

    <div class="product-block mb-3 pt-md-10 pt-0">

      <div class="product-header blocks--border d-flex flex-column">

        <a :href="`/models?category=${modelData.code_category}`" target="_blank" class="product-header__model-category mb-md-6 mb-9 order-2 order-md-1">{{modelData.category}}</a>
        <bim-text-accent bold tag="h1" class="product-header__model-name order-1 order-md-2 mb-6 mb-md-0">{{modelData.name}}{{isBimModel ? ' - BIM модель' : ''}}</bim-text-accent>
        <div class="ar-mobile order-3 mb-9 mt-6" v-if="linkAr && linkAr.length && ($windowWidth <= 767.9 || isIpad)">
          <!--{{slidesLengthMobileSlider}}-->
          <div class="posr" v-swiper:mobileSwiperAr="swiperOptionMobileAr">
            <div class="swiper-wrapper">
              <div
                v-if="(isIos && slide.system !== 'android') || (isAndroidOs && slide.system !== 'ios')"
                class="swiper-slide"
                :key="slide.src + slide.iosSrc"
                v-for="slide in linkAr"
              >
                <div class="ar-block">
                  <model-viewer style="height: 50vh; max-height: 80%; width: 100%" autoplay="" id="reveal" preload ar="true" ar-modes="webxr scene-viewer quick-look fallback" :src="slide.src" :ios-src="slide.iosSrc" quick-look-browsers="safari chrome" alt="3d model" camera-controls background="transparent" ></model-viewer>
                </div>
              </div>
            </div>
            <bim-button
              v-if="linkAr && linkAr.length > 1"
              text-color="#4d4d4d"
              color="white"
              icon-size="18"
              rounded
              icon="icon-arrow-left22"
              class="slider-arrows slider-arrows--prev slider-arrows--ar-models"
            />
            <bim-button
              v-if="linkAr && linkAr.length > 1"
              text-color="#4d4d4d"
              color="white"
              icon-size="18"
              rounded
              icon="icon-arrow-right22"
              class="slider-arrows slider-arrows--next slider-arrows--ar-models"
            />
          </div>
          <bim-text-desc bold v-if="linkAr && linkAr.length > 1" class="mt-6">
            <div class="swiper-pagination ar-pagination"></div>
          </bim-text-desc>
        </div>

        <bim-button
          @click="openDownloadModal"
          width="100%"
          size="l"
          label="Скачать модель"
          class="order-4 d-md-none"
        />

        <!--Модалка необходима авторизация-->
        <popup width="450px" title="Внимание!" v-model="open.auth">
          <div>
            <bim-text class="mb-6" type="main">Для скачивания модели вам необходимо авторизоваться либо зарегистрироваться на нашем портале</bim-text>
            <bim-button width="100%" label="Авторизоваться / Зарегистрироваться" @click="openLoginPage" />
          </div>
        </popup>

        <!--Модалка скачивания модели-->
        <popup v-model="open.download" title="Выберите формат для скачивания" width="300px">
          <div v-for="link in modelData.files" :key="link.id" @click="downloadModel(link.id)" class="download-product-link d-flex align-center">
            <bim-text-medium tag="span" class="download-product-link__name">{{link.name | cut(25)}}</bim-text-medium>
            <bim-text-medium tag="span" class="download-product-link__size ml-auto">{{convertToMegabyte(link.file_size)}}</bim-text-medium>
          </div>
        </popup>
      </div>

      <!--Обзор-->
      <div class="product-view blocks--border">
        <div @click="open.view = !open.view" class="header-button blocks--paddings" :class="{active: open.view}">
          <bim-text-main bold tag="h2">Обзор</bim-text-main>
        </div>
        <div class="hidden-content" :class="{active: open.view}">
          <!--Слайдер-->
          <div class="slider-box mb-md-10 mb-9" v-if="sliderData.length > 1">
            <div v-swiper:swiperModel="swiperOption">
              <div class="swiper-wrapper">
                <div class="swiper-slide" :key="slide.id" v-for="slide in sliderData">
                  <!--Изображение слайдер-->
                  <div @click="openModalImages(slide.position)" v-if="slide.type === 'image'" class="product-view__slide-wrapper">
                    <img class="product-view__slide-image" :src="slide.src">
                  </div>
                  <!--AR-модель-->
                  <div v-metric="'VIEW_MODEL3D'" @click="openModalAr(slide.link)" v-if="slide.type === 'modelAr'" class="product-view__slide-wrapper">
                    <img class="product-view__slide-image product-view__3d-image" :src="slide.src">
                    <span class="tag-3d">
                      <img class="tag-3d__image" src="/dist/assets/front_white/img/models/3d-icon.svg" />
                      <div class="tag-3d__text">Посмотрите в 3D</div>
                    </span>
                  </div>
                  <!--3d-модель-->
                  <!--<div @click="open.model3d = true" v-if="slide.type === 'model3d'" class="product-view__slide-wrapper">-->
                  <!--  <img class="product-view__slide-image" :src="slide.src">-->
                  <!--  <span class="tag-3d">3D</span>-->
                  <!--</div>-->
                  <!--Видео-->
                  <div v-if="slide.type === 'video'" class="product-view__slide-wrapper">
                    <vue-plyr :options="playerOptions" class="lazy-load-on video-component">
                      <div class="plyr__video-embed">
                        <iframe
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                          frameborder="0"
                          height="315"
                          :src="slide.src"
                        ></iframe>
                      </div>
                    </vue-plyr>
                  </div>
                </div>
              </div>
            </div>
            <bim-button text-color="#4d4d4d" color="white" icon-size="18" rounded icon="icon-arrow-left22" id="content-button-prev" class="swiper-button-prev slider-arrows"/>
            <bim-button text-color="#4d4d4d" color="white" icon-size="18" rounded icon="icon-arrow-right22" id="content-button-next" class="swiper-button-next slider-arrows"/>
          </div>

          <p class="mb-2" v-html="description"></p>

          <span
            v-if="modelData.description.length > maxDescription"
            @click="open.description = !open.description"
            class="show-description"
          >
          {{ !open.description ? 'Показать больше' : 'Показать меньше' }}
        </span>
        </div>
      </div>

      <!--Основные характеристики-->
      <div v-if="mainCharIsExist" class="product-main-characteristics blocks--border">
        <div @click="open.mainChar = !open.mainChar" class="header-button blocks--paddings" :class="{active: open.mainChar}">
          <bim-text-main bold tag="h2">Основные характеристики</bim-text-main>
        </div>
        <div class="hidden-content" :class="{active: open.mainChar}">
          <ul class="mainChar-list">
            <li v-if="modelData.width && modelData.width > 0" class="mainChar-item list-item">
              <span class="list-item__title">Ширина</span>
              <span class="list-item__value">{{ modelData.width | discharge }} мм</span>
            </li>
            <li v-if="modelData.length && modelData.length > 0" class="mainChar-item list-item">
              <span class="list-item__title">Длина</span>
              <span class="list-item__value">{{ modelData.length | discharge }} мм</span>
            </li>
            <li v-if="modelData.height && modelData.height > 0" class="mainChar-item list-item">
              <span class="list-item__title">Высота</span>
              <span class="list-item__value">{{ modelData.height | discharge }} мм</span>
            </li>
            <li v-if="modelData.weight && modelData.weight > 0" class="mainChar-item list-item">
              <span class="list-item__title">Вес</span>
              <span class="list-item__value">{{ modelData.weight / 1000 | discharge }} кг</span>
            </li>
            <li v-if="modelData.diametr && modelData.diametr > 0" class="mainChar-item list-item">
              <span class="list-item__title">Диаметр</span>
              <span class="list-item__value">{{ modelData.diametr | discharge }} мм</span>
            </li>
          </ul>
        </div>
      </div>

      <!--Технические характеристики-->
      <div v-if="techCharIsExist" class="product-main-characteristics blocks--border">
        <div @click="open.techChar = !open.techChar" class="header-button blocks--paddings" :class="{active: open.techChar}">
          <bim-text-main bold tag="h2">Технические характеристики</bim-text-main>
        </div>
        <div class="hidden-content" :class="{active: open.techChar}">
          <ul class="techChar-list">
            <li v-if="modelData.code_category_name" class="techChar-item list-item">
              <span class="list-item__title">Раздел</span>
              <span class="list-item__value">{{ modelData.code_category_name }}</span>
            </li>
            <li v-if="modelData.code_type_name" class="mainChar-item list-item">
              <span class="list-item__title">Категория</span>
              <span class="list-item__value">{{ modelData.code_type_name }}</span>
            </li>
            <li v-if="modelData.code_class_name" class="mainChar-item list-item">
              <span class="list-item__title">Подкатегория</span>
              <span class="list-item__value">{{ modelData.code_class_name }}</span>
            </li>
            <li v-if="modelData.building && modelData.building.length" class="mainChar-item list-item">
              <span class="list-item__title">Здания</span>
              <div class="list-item__value">
                <a
                  :href="`/models?objects=${building.code}`"
                  target="_blank"
                  v-for="building in modelData.building"
                  :key="building.code"
                  class="link-second"
                >{{ building.name }}
                </a>
              </div>
            </li>
            <li v-if="modelData.rooms && modelData.rooms.length" class="mainChar-item list-item">
              <span class="list-item__title">Тип помещения</span>
              <div class="list-item__value">
                <a
                  :href="`/models?aparts=${room.code}`"
                  target="_blank"
                  v-for="room in modelData.rooms"
                  :key="room.code"
                  class="link-second"
                >{{ room.name }}
                </a>
              </div>
            </li>
            <li v-if="modelData.materials && modelData.materials.length" class="mainChar-item list-item">
              <span class="list-item__title">Материалы</span>
              <div class="list-item__value">
                <a
                  :href="`/models?materials=${material.code}`"
                  target="_blank"
                  v-for="material in modelData.materials"
                  :key="material.code"
                  class="link-second"
                >{{ material.name }}
                </a>
              </div>
            </li>
            <li v-if="modelData.modelRegions && modelData.modelRegions.length" class="mainChar-item list-item">
              <span class="list-item__title">Регионы</span>
              <div class="list-item__value">
              <span
                v-for="region in modelData.modelRegions"
                :key="region.id"
                class="link-second"
              >{{ region.attr_value }}</span>
              </div>
            </li>
            <li v-if="modelData.link_catalog" class="mainChar-item list-item">
              <span class="list-item__title">Каталог</span>
              <a :href="modelData.link_catalog" rel="nofollow" target="_blank" class="list-item__value link-second">Перейти</a>
            </li>
          </ul>
        </div>
      </div>

      <!--Документация к продукту-->
      <div v-if="false" class="product-documentation blocks--border">
        <div @click="open.documentation = !open.documentation" class="header-button blocks--paddings" :class="{active: open.documentation}">
          <bim-text-main bold tag="h2">Документация к продукту</bim-text-main>
        </div>
        <div class="hidden-content" :class="{active: open.documentation}">
          <ul class="documents-list">
            <li class="documents-list__item">
              <h3 class="documents-list__title mb-3">Технический лист модельного ряда.pdf</h3>
              <a href="#" class="documents-list__link">
                <i class="icon-download-arrow"></i>
                Скачать
              </a>
            </li>
            <li class="documents-list__item">
              <h3 class="documents-list__title mb-3">Документация о праве на публикацию.doc</h3>
              <a href="#" class="documents-list__link">
                <i class="icon-download-arrow"></i>
                Скачать
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!--Сайдбар (для мобильных)-->
      <Sidebar v-if="$windowWidth <= 767.9" v-bind="$props"/>

      <!--Еще продукты производителя-->
      <div v-if="false" class="product-more-models">
        <div
          @click="open.productManufacturer = !open.productManufacturer"
          class="header-button blocks--paddings"
          :class="{active: open.productManufacturer}"
        >
          <bim-text-main bold tag="h2">Еще продукты производителя</bim-text-main>
        </div>
        <div class="hidden-content" :class="{active: open.productManufacturer}">
          <div class="product-card-wrapper d-flex flex-wrap justify-space-between">
            <Card v-for="card in 8" :key="card" class="product-card--amount"/>
          </div>
        </div>
      </div>
    </div>
    <!--Похожие модели-->
    <div v-if="false" class="product-block mb-3 p-md-9 px-0">
      <bim-text-main bold tag="h2" class="mb-9">Похожие модели</bim-text-main>
      <div class="product-card-wrapper d-flex flex-wrap justify-space-between">
        <Card v-for="card in 8" :key="card.id" class="product-card--amount"/>
      </div>
    </div>

    <!--<popup v-model="open.model3d" title="Просмотр 3D-модели" width="700px">-->
    <!--  <Viewer3d :src="modelData.Viewer3D" stl/>-->
    <!--</popup>-->

    <popup v-model="open.modelAr" title="Просмотр 3D-модели" width="900px">
      <Viewer3d :src="modelArLink"/>
    </popup>

    <ModalSlider
      v-if="open.imagesSlider"
      @close="open.imagesSlider = false"
      :images="modelData.images"
      :index-clicked-slide="indexCurrentClickedSlide"
    />

    <!--<pre>youtube: {{modelData.link_youtube}}</pre>-->
    <!--<pre>3d: {{modelData.Viewer3D}}</pre>-->
    <!--<pre>Ar andro: {{modelData.AndroidViewer3D}}</pre>-->
    <!--<pre>Ar apple: {{modelData.iPhoneViewer3D}}</pre>-->
    <!--<pre>Images: {{modelData.images_down}}</pre>-->
    <!--<pre>{{sliderData}}</pre>-->
  </div>
</template>

<script>
import bimTextAccent from '@bimlib/components/bimTextAccent'
import bimTextDesc from '@bimlib/components/bimTextDesc'
import bimTextMain from '@bimlib/components/bimTextMain'
import bimTextMedium from '@bimlib/components/bimTextMedium'
import bimText from '@bimlib/components/bimText'

import bimSelect from '@bimlib/components/bimSelect'
import popup from '@bimlib/components/bimPopup'

import Sidebar from './Sidebar'
import Card from '@/components/models/Card'
import ModalSlider from '@/pages/models/SingleModalSlider'
import Viewer3d from '@/pages/models/Model3d'

import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import downloadMixin from '@/mixins/models/downloadModel.mixin'

export default {
  name: 'Content',
  components: {
    bimTextAccent,
    bimTextMain,
    bimTextDesc,
    bimTextMedium,
    bimSelect,
    bimText,
    Card,
    popup,
    Viewer3d,
    ModalSlider,
    Sidebar,
  },
  directives: {
    swiper: directive,
  },
  props: {
    sliderData: Array
  },
  mixins: [downloadMixin],
  data () {
    return {
      slidesLengthMobileSlider: null,
      indexCurrentClickedSlide: null,
      modelArLink: '',
      open: {
        view: true,
        description: false,
        mainChar: true,
        techChar: false,
        documentation: false,
        productManufacturer: true,

        model3d: false,
        imagesSlider: false,
        modelAr: false,
      },
      maxDescription: 600,
      cutDescription: 400,
      swiperOption: {
        navigation: {
          nextEl: '#content-button-next',
          prevEl: '#content-button-prev',
        },
        breakpoints: {
          0: {
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 8,
          },
          767.9: {
            freeMode: false,
            slidesPerView: 2,
            spaceBetween: 24,
          },
        },
      },
      swiperOptionMobileAr: {
        loop: this.linkAr && this.slidesLengthMobileSlider > 1,
        noSwiping: true,
        noSwipingClass: 'swiper-wrapper',
        navigation: {
          nextEl: '.slider-arrows--next',
          prevEl: '.slider-arrows--prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          renderFraction: (currentClass, totalClass) => {
            return this.slidesLengthMobileSlider > 1 ? '<span class="' + currentClass + '"></span>' +
              ' из ' +
              '<span class="' + totalClass + '"></span>' : ''
          },
        },
        slidesPerView: 1,
        spaceBetween: 8,
      },
      playerOptions: {
        controls: ['play-large', 'play', 'progress', 'mute', 'fullscreen'],
        clickToPlay: true,
        youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
      },
      bimModelValidationFiles: ['rvt', 'rfa', 'rte', 'ifc', 'pln', 'pla', 'prt', 'sldprt', 'asm', 'sldasm', 'nas', 'mod', 'afs', 'c3d', 'tbp', 'ipt', 'iam', '3ds', 'dxf', 'sat', 'dgn', 'gbxml', 'dwg'],
    }
  },
  mounted () {
    this.slidesLengthMobileSlider = this.linkAr.length
  },
  computed: {
    isIpad() {
      if ((/\b(iPad)\b/.test(navigator.userAgent)
        && /WebKit/.test(navigator.userAgent)
        && !window.MSStream)
        || (navigator.platform === 'MacIntel'
          && navigator.maxTouchPoints === 5)
      ) {
        return true
      }
    },
    /**
     * Проверка на BIM модель - проверяет по массиву расширений. Если совпадает, значит это бим модель
     * @return {boolean}
     */
    isBimModel () {
      if (typeof this.modelData.files_ext === "undefined") return false
      return false // !!this.modelData.files_ext.find(el => this.bimModelValidationFiles.indexOf(el) !== -1)
    },
    /**
     * Проверка на наличие хотя бы одной основной характеристики
     * @return {boolean}
     */
    mainCharIsExist () {
      return this.modelData.width > 0 || this.modelData.length > 0 || this.modelData.height > 0 || this.modelData.weight > 0 || this.modelData.diametr > 0
    },
    /**
     * Проверка на наличие хотя бы одной технической характеристики
     * @return {boolean|number|*}
     */
    techCharIsExist () {
      return (!!this.modelData.code_category_name
        || !!this.modelData.code_type_name
        || !!this.modelData.code_class_name
        || !!this.modelData.link_catalog
        || (!!this.modelData.building && this.modelData.building.length)
        || (!!this.modelData.rooms && this.modelData.rooms.length)
        || (!!this.modelData.materials && this.modelData.materials.length)
        || (!!this.modelData.modelRegions && this.modelData.modelRegions.length)
      )
    },
    /**
     * Вычисляет длину описания и обрезает по превышению максимально разрешенной длины
     * @return {string} текст описания
     */
    description () {
      const description = this.modelData.description
      if (description.length > this.maxDescription && !this.open.description) {
        return this.$options.filters.cut(description, this.cutDescription, 'end')
      } else {
        return description
      }
    },
  },
  methods: {
    openModalAr (link) {
      this.open.modelAr = true
      this.modelArLink = link
    },
    /**
     * Открывание модального окна со слайдром картинок.
     * @param idx - индекс кликнутой картинки. Требуется для слайдера в модалке. По этому индексу он перелистывается на нужный слайд
     */
    openModalImages (idx) {
      this.indexCurrentClickedSlide = idx
      this.open.imagesSlider = true
    },
  },
}
</script>

<style lang="scss" scoped>
  .auth-text {
    margin-bottom: 20px;
  }
</style>
